<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-left mt-4 card card-pricing text-center">
            <div class="bg-transparent card-header pt-4 border-0">
                <h4 class="h4 font-weight-normal text-primary text-center mb-0">
                    {{ $t('hec.policyRenewal.title') }}
                </h4>
            </div>
            <div class="card-body p-0">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="text-left text-hec"><h5>{{ $t('hec.policyRenewal.termsOfUse') }}</h5></div>
                            <form @submit.prevent="handleOnSubmit">
                                <div class="row form-header border-0">
                                    <div class="col mt-12 text-left p-1">
                                        {{ $t('hec.policyRenewal.description') }}
                                </div>
                                </div>
                                <div class="row form-main border" >
                                    <MembershipFeePolicyDetail @displayed="policyDisplayed"/>
                                </div>
                                <div class="row form-footer"/>
                                <div class="row mt-2">
                                    <div class="col col-12 form-check text-left text-md-center">
                                        <input v-model="formData.agree" name="agree" type="checkbox" @click="checkbox()" ref="checked_forthing"
                                        class="form-check-input" id="agree" :disabled="dontLetAgree">
                                        <label class="form-check-label-policy" for="agree">
                                        {{ $t('hec.policyRenewal.agree' )}}
                                        </label>
                                    </div>
                                    <div class="col col-12 text-left text-md-center">
                                        {{ $t('hec.policyRenewal.requireScroll') }}
                                    </div>
                                </div>

                                <div class="box hec-saving-title-top-margin">
                                    <div class="wrap">
                                        <div class="notes">
                                            <!-- HEC Savingへの自動送付設定に関する同意 -->
                                            <div class="col col-12 text-left text-hec text-top-hec">
                                                <h5>{{ $t('hec.policyRenewal.titleHec') }}</h5>
                                            </div>
                                        </div>
                                    </div> 
                                </div>

                                <div class="box">
                                    <div class="wrap">
                                        <div class="notes">
                                            <div class="text col col-12 text-left-hec text-md-center text-top-hec text-errorMessage">
                                                 <div v-html="$t('hec.policyRenewal.message')"></div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                   
                                <div class="col col-12 text-left text-md-center text-top-hec">
                                    {{ $t('hec.policyRenewal.requireAgreeHec') }}
                                </div>
                                <div class="row mt-2">
                                    <div class="col col-12 form-check text-left text-md-center">
                                        <input v-model="formData.agreeHec" name="agreeHec" type="checkbox" @click="checkbox()" ref="checked_hecsaving"
                                        class="form-check-input" id="agreeHec"> {{ $t('hec.policyRenewal.agreeHec') }}
                                        <label class="form-check-label-policy" for="agreeHec"></label>
                                    </div> 
                                </div>

                                <div class="form-row py-3 justify-content-center">
                                    <div class="col-md-4">
                                        <!-- キャンセルボタン -->
                                        <router-link :to="{ name: 'messages' }" class="text-center">
                                            <span class="btn btn-light btn-block">{{ $t('hec.policyRenewal.cancelButton') }}</span>
                                        </router-link>
                                    </div>
                                    <!-- 次へボタン -->
                                    <div class="col-md-4 mt-2 mt-md-0">
                                        <button id="nextBtn" type="button" class="btn btn-primary btn-block btn-disable">{{ $t('hec.policyRenewal.nextButton') }}</button>                                            
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "../../services/UserService";
    import MembershipFeePolicyDetail from './../../components/MembershipFeePolicyDetail';

    export default {
        name: 'MembershipFeePolicy',

        components: {
            MembershipFeePolicyDetail,
        },

        data() {
            return {
                formData: {
                    agree: false,
                    agreeHec: false
                },
                readyReadTerms: false,
                requireAgree: false,
                lang: '',
                readyReadTermsHec: false,
                equireAgreeHec: false,
                is_hecsaving_applied: false,
                checked_forthing: false,
                checked_hecsaving: false,
            }
        },

        async created() {
            this.fetchData()
        },

        mounted() {
        },

        methods: {
            async fetchData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.is_hecsaving_applied = data.is_hecsaving_applied;
            },
            policyDisplayed() {
                this.readyReadTerms = true;
                this.readyReadTermsHec = true;
            },
            async checkbox() {
                const target = document.getElementById("nextBtn");
                if( this.$refs.checked_forthing.checked  && 
                    this.$refs.checked_hecsaving.checked  &&  
                    this.is_hecsaving_applied
                ) {
                    target.classList.remove("btn-disable");
                    target.type = "submit";
                }else{
                    target.classList.add("btn-disable");
                    target.type = "button";
                }
            },
            async handleOnSubmit() {
                //画面遷移する場合
                this.$router.push('/membership/payment-renewal');
            },
        },
        computed: {
            dontLetAgree() {
                return !this.readyReadTerms;
            },
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .form-header {
        background: #451493;
        color: #fff;
    }

    .form-footer {
        background: #451493;
        color: #fff;
        height: 30px;
    }

    .form-main textarea {
        width: 100%;
    }

    .form-main div {
        width: 100%;
        height: 200px;
        overflow:auto;
    }

    .form-check {
        font-size: 110%;
    }

    .form-check-label-policy{
        margin-bottom: 0;
        white-space: nowrap;
    }

    .card {
        border: 0px;
    }

    .card-pricing .list-unstyled li {
        padding: .5rem 0;
        color: #6c757d;
    }
    .card-deck .card {
        flex: inherit !important;
    }
    .card-deck {
        padding: 0 0 0 10px;
    }
    .center-items {
        justify-content: center;
    }
    .hide-border {
        border-top: none !important;
    }
    .disabled-button {
        opacity: 0.5;
    }
    .form-button {
        max-width: 150px;
    }
    .text-hec {
        font-weight: bold !important;
    }
    .text-top-hec {
        padding-top: 20px !important;
    }
    .text-left-hec {
        text-align: left !important;
    }
    .text-errorMessage {
        color: #e3342f;
    }
    .box {
        text-align:left;
        border-top-width: 0px;
    }
    .wrap {
        margin-left: auto;
    }
    .notes {
        width: 100%;
        display: flex;
        max-width: 568px;
        margin: 0 auto;
    }
    .btn-disable {
        background: #c6c6c6;
        color: #fff;
        border: #c6c6c6;
    }
    .btn-disable:focus  {
        background: #c6c6c6 !important;
        color: #fff !important;
        border: #c6c6c6 !important;
        box-shadow: 0 0 0 0.2rem #f8f9fa !important;
    }
    .btn-disable:active  {
        background: #c6c6c6 !important;
        color: #fff !important;
        border: #c6c6c6 !important;
    }
    .hec-saving-title-top-margin {
         margin-top: 50px !important;
    }
    @media screen and (max-width: 991px) {
        .btn:hover {
            color: #fff !important;
        }
    }
</style>
